/**
 * The below file contains the Sagas method for Fire Agency.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { Error, Success } from "constants/ApiConstant";
import {
  Fire_Agency_Imported,
} from "constants/MessageConstant";
import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { showMessage } from "redux/actions/Common";
import {
  setAllFireAgency,
} from "redux/actions/FireAgency";
import {
  GET_ALL_FIRE_AGENCY,
} from "redux/constants/FireAgency";
import FireAgencyService from "services/FireAgencyService";

//#region Method for listing

/**
 * Method for getting the fire agency
 */
export function* getAllFireAgency() {
  yield takeEvery(GET_ALL_FIRE_AGENCY, function* () {
    try {
      const fire = yield call(FireAgencyService.getAllFireAgency);
      if (fire.error != null && fire.error.message) {
        yield put(showMessage({ message: fire.error.message, type: Error }));
      } else {
        yield put(setAllFireAgency(fire));
      }
    } catch (err) {
      yield put(
        showMessage({ message: err.response.data.error.message, type: Error })
      );
    }
  });
}

//#endregion Method for listing

/**
 * Method for storing the multiple Sagas method
 */
export default function* rootSaga() {
  yield all([
    fork(getAllFireAgency),
  ]);
}
